module.exports = __webpack_public_path__ + "img/sedo.03c3af8e.png";